import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_437: DocMigration = {
  maxSchemaVersion: "0.0.437",
  description: "Remove built-in plan sections",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];
      if (settings.type !== "PLAN_SETTINGS") {
        continue;
      }

      delete settings.enableFrontSectionPlane;
      delete settings.enableRightSectionPlane;
      delete settings.enableLeftSectionPlane;
      delete settings.enableBackSectionPlane;
      delete settings.frontSectionPlaneDistance;
      delete settings.rightSectionPlaneDistance;
      delete settings.leftSectionPlaneDistance;
      delete settings.backSectionPlaneDistance;
    }

    return json;
  },
};

export default migration_0_0_437;
